import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const ChineseAstrologyContainer = styled.div`
  padding-bottom: 5px;
  width: 100%;
  margin-top: 5px;
  ${breakpoints.phone} {
    margin-left: 0;
  }
  .line-top{
    border-top: 1px solid ${Color.greySeparator};
    margin-bottom: 15px 0px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        border-top:1px solid ${ColorDark.greySeparator};
      }
    }
  }
  .chinese-astrology-header {
    align-items: flex-start;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    flex-direction: column;
    .chinese-astrology-landing-header-title {
      ${Font.clarinVarSub2Regular};
      font-size: 36px;
      color: ${Color.grey};
      position: relative;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
          color: ${ColorDark.textLight};
        } 
      }
      ${breakpoints.phone} {
        font-size: 26px;
      }
    }
    .chinese-astrology-header-title {
      ${Font.sansBold};
      color: ${Color.black000};
      font-size: 20px;
      position: relative;
      padding-top: 15px;
      ${breakpoints.darkMode} {

      [data-theme='dark'] & {
        color:${ColorDark.textLight};
      }
      }
      ${breakpoints.phone} {
        font-size: 18px;
      }
    }
    .chinese-astrology-landing-description-text {
      ${Font.clarinVarSub2Regular};
      font-size: 21px;
      line-height: 26px;
      color: ${Color.grey};
      margin-top: 8px;
      padding-bottom: 15px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:${ColorDark.textLight};
        }
      }

      ${breakpoints.phone} {
        font-size: 17px;
      }
    }
  }
  .chinese-astrology-description {
    margin-bottom: 30px;
    width: 100%;
    margin-top: 16px;
    height: 108px;
    background-color: ${Color.greyF5F5F5};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    gap: 20px;
    position: relative;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      background-color:${ColorDark.darkGrey};
      }
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: ${Color.greySeparator};
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color:${ColorDark.greySeparator};
        }
      }
    }
    ${breakpoints.tablet} {
      flex-direction: column;
      height: auto;
      padding: 20px;
    }
    ${breakpoints.phone} {
      flex-direction: column;
      height: auto;
      padding: 20px;
    }
    .chinese-astrology-description-text {
      ${Font.sansRegular};
      color: ${Color.grey};
      font-size: 16px;
      line-height: 22px;
      width: 50%;
      text-align: left;
      border-right: 2px solid ${Color.grey777};
      padding-right: 15px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:${ColorDark.textLight};
        border-right: 2px solid ${ColorDark.greySeparator};
        }
      }
      ${breakpoints.phone} {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #999;
        padding-bottom: 15px;
      }
      ${breakpoints.tablet} {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #999;
        padding-bottom: 15px;
      }
    }
    .chinese-astrology-input {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;
      ${breakpoints.tablet} {
        width: 100%;
        flex-direction: column;
      }
      ${breakpoints.phone} {
        width: 100%;
        flex-direction: column;
      }
      .chinese-astrology-input-text {
        ${Font.sansBold};
        color: ${Color.grey};
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color:${ColorDark.textLight};
          }
        }
      }
      .chinese-astrology-inputs-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        input {
          width: 103px;
          height: 54px;
          background-color: ${Color.white};
          outline: 2px solid ${Color.greySeparator};
          border: none;
          ${Font.sansRegular};
          color: ${Color.greySeparator};
          font-size: 15px;
          text-align: center;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            background-color:${ColorDark.backDarknew};
            outline: 2px solid ${ColorDark.greySeparator};
              color:${ColorDark.textLight};
            }
            
          }
          ${breakpoints.phone} {
            width: 60%;
            text-align: center;
          }
          ${breakpoints.tablet} {
            width: 60%;
            text-align: center;
          }
          &:focus {
            outline: 2px solid ${Color.mainColor};
            color: ${Color.mainColor};
          }
        }
        .chinese-astrology-input-button {
          width: 112px;
          height: 39px;
          background-color: ${Color.greySeparator};
          border-radius: 50px;
          border: none;
          ${Font.sansBold};
          color: ${Color.white};
          font-size: 16px;
          padding: 10px 28px 9px;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            background-color:${ColorDark.greySeparator};
              color:${ColorDark.textLight};
            }
          }
          &:hover {
            background-color: ${Color.mainColor};
            color: ${Color.white};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color:${ColorDark.textLight};
              background-color: ${ColorDark.mainColor};
              }

            }
          }
        }
      }
    }
    .chinese-astrology-landing-input {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 30px;
      ${breakpoints.phone} {
        width: 100%;
        flex-direction: column;
      }
      .chinese-astrology-input-text {
        ${Font.sansBold};
        color: ${Color.grey};
        font-size: 16px;
        text-align: left;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color:${ColorDark.textLight};
          }
        }
      }
      .chinese-astrology-inputs-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 30px;
        input {
          width: 189px;
          height: 54px;
          background-color: ${Color.white};
          outline: 2px solid ${Color.greySeparator};
          border: none;
          ${Font.sansRegular};
          color: ${Color.greySeparator};
          font-size: 15px;
          text-align: center;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            background-color:${ColorDark.backDarknew};
            outline: 2px solid ${ColorDark.greySeparator};
              color:${ColorDark.textLight};
            }
            
          }
          ${breakpoints.phone} {
            width: 60%;
            text-align: center;
          }
          &:focus {
            outline: 2px solid ${Color.mainColor};
            color: ${Color.mainColor};
          }
        }
        .chinese-astrology-input-button {
          width: 112px;
          height: 39px;
          background-color: ${Color.greySeparator};
          border-radius: 50px;
          border: none;
          ${Font.sansBold};
          color: ${Color.white};
          font-size: 16px;
          padding: 10px 28px 9px;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            background-color:${ColorDark.greySeparator};
              color:${ColorDark.textLight};
            }
            
          }
          &:hover {
            background-color: ${Color.mainColor};
            color: ${Color.white};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color:${ColorDark.textLight};
              background-color: ${ColorDark.mainColor};
              }

            }
          }
        }
      }
    }
  }
`;
